import { computed } from 'vue';
import { PROFILE_TYPES, ProfileRecord, RECORD_TYPE } from '@/app/data/model_constants';
import { mapGetters } from '@/store/lib/vue3helpers.js';

export function isProfilePaused(profile) {
  return profile.type === PROFILE_TYPES.EMPLOYEE && profile.attributes.status === ProfileRecord.STATUS_BLOCKED;
}

export default function useTenantProfile() {
  const {
    current_user_customers,
    current_user_employees,
    current_user_partners,
    current_user_projects,
    current_user_supervisors,
  } = mapGetters([
    'current_user_customers',
    'current_user_employees',
    'current_user_partners',
    'current_user_projects',
    'current_user_supervisors',
  ]);

  const profiles = computed(() =>
    [
      Object.values(current_user_supervisors.value),
      Object.values(current_user_employees.value),
      Object.values(current_user_customers.value),
      Object.values(current_user_partners.value),
    ].flat(),
  );

  function profileOf(tenant) {
    if (tenant.attributes.name === 'supervisor') return Object.values(current_user_supervisors.value)[0];

    const client_id =
      tenant.attributes.tenantable_type === RECORD_TYPE.PROJECT
        ? current_user_projects.value[tenant.attributes.tenantable_id].attributes.client_id
        : tenant.attributes.tenantable_id;
    return profiles.value.find((profile) => profile.attributes.client_id === client_id);
  }

  return { profileOf };
}
